import React from 'react';
import PropTypes from 'prop-types';
import TextInputField from 'material-ui/TextField';
import { TableRowColumn } from 'material-ui/Table';

const TimeTableCell = (props) => {
    const { name, onChangeInput, style, value } = props;

    return (
        <TableRowColumn style={ style }>
            <TextInputField
                id={ value.id ? `${ value.id }` : '' }
                value={ value[name] || '' }
                name={ name }
                onChange={ (e) => {
                    return onChangeInput(e, value);
                } }
                type='time'
            />
        </TableRowColumn>
    );
};

TimeTableCell.defaultProps = {
    name: 'timeTableCell',
    onChangeInput: () => {},
    value: {},
};

TimeTableCell.propTypes = {
    name: PropTypes.string,
    onChangeInput: PropTypes.func,
    style: PropTypes.object,
    value: PropTypes.object,
};

export default TimeTableCell;


// WEBPACK FOOTER //
// ./src/pages/products/configuration/TimeTableCell.js